// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"1099d23f","628":"9d02de5a","963":"a4332311","988":"dfec2777"}[chunkId] + ".chunk.js";
};